import { useTaskSuggestions } from '@/hooks/useTaskSuggestions';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Sparkles } from 'lucide-react';

export function TaskSuggestionsIndicator() {
  const { suggestionsCount } = useTaskSuggestions();

  if (suggestionsCount === 0) return null;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => window.dispatchEvent(new CustomEvent('open-task-suggestions'))}
      className="fixed bottom-6 right-6 z-50 shadow-lg"
    >
      <Sparkles className="h-4 w-4 mr-2 text-purple-500" />
      {suggestionsCount} Task Suggestion{suggestionsCount !== 1 ? 's' : ''}
      <Badge variant="secondary" className="ml-2">
        Review
      </Badge>
    </Button>
  );
}
